import { render, staticRenderFns } from "./expert-result.vue?vue&type=template&id=e16a9b0a&"
import script from "./expert-result.vue?vue&type=script&lang=ts&"
export * from "./expert-result.vue?vue&type=script&lang=ts&"
import style0 from "./expert-result.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports